export const SET_FAVOURITE_ACTION = 'SET_FAVOURITE_ACTION';
export const SET_FAVOURITE_SUCCESS_ACTION = 'SET_FAVOURITE_SUCCESS_ACTION';
export const SET_FAVOURITE_FAILURE_ACTION = 'SET_FAVOURITE_FAILURE_ACTION';
